import { BreadcrumbsWidget } from "components";

const PageTitle = ({ id, singleData }) => {
  return (
    <div className="w-full mb-6">
      <BreadcrumbsWidget
        data={[
          { title: "Ürünler", url: "/products/0" },
          {
            title: `${singleData.data?.parentCategory?.tr_baslik} Ürünleri`,
            url: `/get-products/${singleData.data?.parentCategory?.id}`,
          },
        ]}
        activeItem={id > 0 ? "Ürün Düzenle" : "Ürün Ekle"}
      />
    </div>
  );
};

export default PageTitle;
